import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/components/Layout";
Vue.use(VueRouter);

export const constantRoutes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login"),
    hidden: true // 不在侧边栏显示
  },
  {
    path: "/",
    component: Layout,
    redirect: "/report",
    meta: { sort: 1 },
    children: [
      {
        path: "/report",
        name: "Report",
        component: () => import("@/views/report"),
        meta: { title: "企业尽调报告" }
      }
    ]
  },
  {
    path: "/assess",
    component: Layout,
    redirect: "/assess/assessment",
    meta: { title: "我的评估项目", sort: 2 },
    children: [
      {
        path: "assessment",
        name: "Assessment",
        component: () => import("@/views/assess"),
        hidden: true,
        meta: { activeMenu: "/assess" }
      },
      {
        path: "patent",
        name: "Patent",
        component: () => import("@/views/patent"),
        hidden: true,
        meta: { activeMenu: "/assess" }
      },
      {
        path: "flow",
        name: "Flow",
        component: () => import("@/views/flow"),
        hidden: true,
        meta: { activeMenu: "/assess" }
      }
    ]
  },
  {
    path: "/my",
    component: Layout,
    redirect: "/my/password",
    meta: { sort: 5 },
    children: [
      {
        path: "password",
        name: "Password",
        component: () => import("@/views/my"),
        meta: { title: "个人设置" }
      }
    ]
  }
];

export const asyncRoutes = [
  {
    path: "/child_assess",
    component: Layout,
    redirect: "/child_assess/assessment",
    meta: { title: "子账号评估项目", sort: 3, roles: ["admin"] },
    children: [
      {
        path: "assessment",
        name: "ChildAssessment",
        component: () => import("@/views/childAssess"),
        hidden: true,
        meta: { activeMenu: "/child_assess" }
      },
      {
        path: "patent",
        name: "ChildPatent",
        component: () => import("@/views/patent"),
        hidden: true,
        meta: { activeMenu: "/child_assess" }
      },
      {
        path: "flow",
        name: "ChildFlow",
        component: () => import("@/views/flow"),
        hidden: true,
        meta: { activeMenu: "/child_assess" }
      }
    ]
  },
  {
    path: "/child_account",
    component: Layout,
    redirect: "/child_account/list",
    meta: { title: "子账号列表", sort: 4, roles: ["admin"] },
    children: [
      {
        path: "list",
        name: "ChildAccount",
        component: () => import("@/views/childAccount"),
        hidden: true,
        meta: { activeMenu: "/child_account" }
      },
      {
        path: "patent",
        name: "ChildPatenta",
        component: () => import("@/views/patent"),
        hidden: true,
        meta: { activeMenu: "/child_account" }
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];

const router = new VueRouter({
  mode: "history",
  routes: constantRoutes
});

export default router;
